import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { UserSettingsUpdatedEventName } from '@/components/user-settings/_domain/models';

@Component({
  name: 'PinNavigationMenuComponent'
})

export default class PinNavigationMenuComponent extends TombolaBaseComponent {
  @Prop() private userPreferences: UserPreferences;
  private pinNavigationMenu: boolean = false;

  protected async created() {
    this.getPinNavigationMenu();
    this.$eventbus.$on(UserSettingsUpdatedEventName, this.getPinNavigationMenu);
  }

  private beforeDestroy(): void {
    this.$eventbus.$off(UserSettingsUpdatedEventName, this.getPinNavigationMenu);
  }

  private getPinNavigationMenu() {
    this.pinNavigationMenu = this.userPreferences.pinNavigationMenu;
  }

  public saveSettings() {
    this.userPreferences.pinNavigationMenu = this.pinNavigationMenu;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/user-settings/_components/pin-navigation-menu/pin-navigation-menu.component.ts